<template>
  <div>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        v-if="item !== null && item !== undefined"
      >
        <v-container>
          <div class="row">
            <div class="col-12 col-md-4 col-lg-3">
              <auto-select
                :value.sync="item.Term"
                :items="terms"
                :label="$t('headers.contributionterms.name')"
                class="required"
                :rules="[$rules.required]"
                :slots="true"
                :filter="transFilterFunc"
                item-value="Id"
              >
                <template v-slot:selection="data">
                  {{ trans(data.item, "FullName") + getTotalDues() }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="trans(data.item, 'FullName')"
                  ></v-list-item-content>
                </template>
              </auto-select>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <auto-select
                :value.sync="item.Type"
                :items="types"
                :label="$t('globals.type')"
                :rules="[$rules.required]"
                :slots="true"
                :filter="filterFunc"
              >
                <template v-slot:selection="data">
                  {{ $t("enums." + data.item) }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content
                    v-text="$t('enums.' + data.item)"
                  ></v-list-item-content>
                </template>
              </auto-select>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <pbas-date-picker
                :label="$t('globals.date')"
                :value="item.PaymentDate"
                @update-date="item.PaymentDate = $event"
                :rules="[$rules.required]"
                class="required"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <currency-textfield
                v-model="item.Amount"
                :label="$t('globals.amount')"
                class="required"
                :rules="[$rules.requiredNum]"
              />
              <!-- <no-autocomplete-textfield
                @blur="amountBlur"
                :label="$t('globals.amount')"
                @change="item.Amount = $event"
                :value="item.Amount"
                prefix="$"
                @keydown="currencyKeydown"
                @keyup="currencyKeyUp"
                class="required"
                :rules="[$rules.requiredNum, $rules.decimal]"
              ></no-autocomplete-textfield> -->
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <no-autocomplete-textfield
                :label="$t('views.planbalance.cheque_number')"
                @change="item.PaymentNumber = $event"
                :value="item.PaymentNumber"
              ></no-autocomplete-textfield>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <v-checkbox
                :label="$t('headers.selfpayments.deposited')"
                v-model="item.Deposited"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <pbas-date-picker
                :label="$t('headers.payments.deposited_date')"
                :value="item.DepositedAt"
                @update-date="item.DepositedAt = $event"
              />
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$emit('close')" :loading="saving">
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn color="primary" :loading="saving" @click="save" :disabled="!valid">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import TransSelect2 from "../../components/TransSelect2";
import AutoSelect from "../../components/AutoSelect";
import { mapActions, mapGetters } from "vuex";
import NoAutocompleteTextfield from "../../components/NoAutocompleteTextfield";
import CurrencyTextfield from "../CurrencyTextfield.vue";
import { translate2 } from "@/trans2";

export default {
  components: {
    TransSelect2,
    NoAutocompleteTextfield,
    AutoSelect,
    CurrencyTextfield,
  },
  props: {
    payment: Object,
    terms: Array,
    saving: Boolean,
  },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    item: null,
    types: [],
    due: [],
  }),
  watch: {
    payment: {
      handler(v) {
        if (v) {
          this.item = v; //JSON.parse(JSON.stringify(v))
        }
      },
    },
    "item.Term": {
      async handler(v) {
        if (v && v.Id) {
          this.due = (await this.getTotalTermDues({
            planIdentityId: this.selectedPlan.Id,
            termId: v.Id,
          })).data.value;
        }
      },
    },
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  mounted() {
    this.item = this.payment;
    this.types = this.options.Enums.PaymentType;
  },
  methods: {
    ...mapActions("plansMembers", ["getTotalTermDues"]),
    save() {
      if (this.item.Id !== null && this.item.Id !== undefined) {
        this.$emit("update", this.item);
      } else {
        this.$emit("add", this.item);
      }
    },
    filterFunc(item, search) {
      return (
        this.$t("enums." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    trans(item, field) {
      return translate2(item, field);
    },
    transFilterFunc(item, search) {
      return (
        this.trans(item, "Name")
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    getTotalDues() {
      if (this.due===null || this.due === undefined) {
        return "";
      }
      const num = parseFloat(this.due)
      if (isNaN(num)) {
        return "";
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return " (" + formatter.format(num) + ")";
    },
  },
};
</script>
